import React, { useState, useEffect } from "react";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import DropdownSelect from "../../../component/Dropdown/DropdownSelect";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { userPerformanceTabWidgets } from "../../../redux/actions/analytics";
import { getUser } from "../../../redux/actions/user";

// Component
import StatusCard from "../Components/StatusCard";
import UserTable from "../Components/UserTable";

function UserPerformanceTab() {
  const [update, setUpdate] = useState(1);
  const [dateRange, setDateRange] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [userSelected, setUserSelected] = useState();

  const dispatch = useDispatch();
  const { userPerformanceWidgets } = useSelector((state) => state.analytics);
  const { color_palettes } = useSelector((state) => state.palettes);

  // Function to get widgets for Collaborator Performance tab
  const getWidgets = (startDate, endDate) => {
    const request = {
      id: userSelected ? userSelected.id : "",
      onError: (error) => {
        console.log(error);
      },
    };
    dispatch(userPerformanceTabWidgets(startDate, endDate, request));
  };

  const getUserList = () => {
    const request = {
      onSuccess: (res) => {
        if (res) {
          const options = res.map((item) => {
            return {
              name: item.name,
              id: item.id,
            };
          });
          setUserOptions(options);
        }
      },
      onError: () => {},
    };
    dispatch(getUser(request));
  };

  useEffect(() => {
    if (dateRange.length === 2) {
      getWidgets(
        moment(dateRange[0]).format("YYYY-MM-DD"),
        moment(dateRange[1]).format("YYYY-MM-DD")
      );
    } else {
      getWidgets();
    }
  }, [dateRange, update, userSelected]);

  useEffect(() => {
    getUserList();
  }, []);

  return (
    <div className="py-2 space-y-4">
      {/* Datepicker Filter and Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="col-span-2 h-[50px] bg-[--bg-color-50] px-4 rounded-md flex items-center space-x-4">
          <div className="w-1/2 flex items-center">
            <h4 className="text-sm font-semibold text-[#313439] leading-5 grow">
              Filters
            </h4>
            <div className="relative">
              <Flatpickr
                data-enable-time
                options={{
                  altFormat: "j M, Y",
                  dateFormat: "Y-m-d H:i",
                  time_24hr: false,
                  disableMobile: true,
                  enableTime: false,
                  altInput: true,
                  mode: "range",
                }}
                placeholder="From - To Date"
                className="form-input !h-7 relative cursor-pointer"
                onChange={(e) => setDateRange(e)}
                value={
                  dateRange.length > 0
                    ? dateRange
                    : [
                        moment().subtract(3, "months").format("YYYY-MM-DD"),
                        moment().format("YYYY-MM-DD"),
                      ]
                }
              />
              {dateRange.length === 0 && (
                <button
                  type="reset"
                  className="hidden absolute right-3 top-1/2 transform -translate-y-1/2 space-x-2 bg-[#fff] z-60"
                >
                  <span className="fa-thin fa-pipe text-[#737373] text-xs"></span>
                  <span className="fa-solid fa-chevron-down text-[#737373] text-xs"></span>
                </button>
              )}
            </div>
          </div>
          <div className="w-1/2 flex justify-end items-center">
            <DropdownSelect
              options={userOptions}
              placeholder="Select User"
              value={userSelected}
              onChange={(e) => setUserSelected(e)}
              css="h-7"
              handleClear={() => setUserSelected()}
            />
          </div>
        </div>
      </div>

      {/* Status card */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div
          className={`bg-[--bg-color-50] h-[100px] rounded-md flex items-center px-4 relative`}
        >
          <StatusCard
            id={userPerformanceWidgets.find(
              (item) => item.analytic_widget_name === "todos_pending"
            )}
            title="To Dos"
            status="Pending"
            statusColor={color_palettes[500]}
            menu={["Add To My Dashboard"]}
            value={
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "todos_pending"
              )?.data?.count
            }
            isDisable={Boolean(
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "todos_pending"
              )?.added_to_dashboard
            )}
            setUpdate={setUpdate}
            update={update}
          />
        </div>
        <div className="bg-[--bg-color-50] h-[100px] rounded-md flex items-center px-4 relative">
          <StatusCard
            id={userPerformanceWidgets.find(
              (item) => item.analytic_widget_name === "todos_overdue"
            )}
            title="To Dos"
            status="Overdue"
            statusColor="#EB5757"
            //cardCss="bg-[--bg-color-50] h-[100px] rounded-md flex items-center px-4 relative"
            menu={["Add To My Dashboard"]}
            value={
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "todos_overdue"
              )?.data?.count
            }
            isDisable={Boolean(
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "todos_overdue"
              )?.added_to_dashboard
            )}
            setUpdate={setUpdate}
            update={update}
          />
        </div>
      </div>

      {/* User Table */}
      <div className="grid gri-cols-1 sm:grid-cols-4 gap-4">
        <div className="bg-[--bg-color-50] h-[340px] rounded-md flex items-center px-4 py-3 relative col-span-2">
          <UserTable
            title="Users"
            menu={["Add To My Dashboard"]}
            setUpdate={setUpdate}
            update={update}
            id={userPerformanceWidgets.find(
              (item) => item.analytic_widget_name === "recent_users"
            )}
            data={
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "recent_users"
              )?.data
            }
            isDisable={Boolean(
              userPerformanceWidgets.find(
                (item) => item.analytic_widget_name === "recent_users"
              )?.added_to_dashboard
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default UserPerformanceTab;
